import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import {
      FormButton,
      FormInput,
      FormSelect,
      FormStatusSelect,
      FormTextarea,
} from "../../components/form";
import { privateApi } from "../../api";

const FaqRequestEdit = () => {
      const { faqId } = useParams();

      const [answer, setAnswer] = useState("");
      const [question, setQuestion] = useState("");
      const [type, setType] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const [types, setTypes] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const loadData = async () => {
            setLoadingData(true);
            await privateApi
                  .get(`/dashboard/faq_requests/${faqId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setType(response.data.faq.faq_type_id);
                              setAnswer(response.data.faq.answer);
                              setQuestion(response.data.faq.question);
                              setStatus(response.data.faq.status);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            await privateApi
                  .get(`/dashboard/faqs/types/list`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setTypes(response.data.types);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  answer: answer,
                  type: type,
                  status: status,
                  question: question,
            };

            await privateApi
                  .post(`/dashboard/faq_requests/${faqId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.question) {
                                    toast.error(response.data.message.question);
                              }
                              if (response.data.message.answer) {
                                    toast.error(response.data.message.answer);
                              }
                              if (response.data.message.type) {
                                    toast.error(response.data.message.type);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Faq">
                                                <LinkButton
                                                      link="/dashboard/faqs/requests"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Question"
                                                            required={true}
                                                            value={question}
                                                            classes={8}
                                                            handleChange={
                                                                  setQuestion
                                                            }
                                                      />
                                                      <FormSelect
                                                            title="Type"
                                                            required={true}
                                                            selected={type}
                                                            loading={
                                                                  loadingData
                                                            }
                                                            setData={setType}
                                                            classes={4}
                                                            options={types}
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormTextarea
                                                            title="Answer"
                                                            value={answer}
                                                            required={true}
                                                            handleChange={
                                                                  setAnswer
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default FaqRequestEdit;
